<template>
	<fragment>
		<class-header
			:subname="lecture.category"
			:name="lecture.lecName"
			v-bind:menus="menus"
			v-bind:buttons="buttons"
			v-bind:mainmenuOpened="true"
			v-bind:sysmenuActive="false"
			:icon="lecture.lecIcon?lecture.lecIcon.atchFileId:''"
		></class-header>

		<section ref="container" class="container">
			<nav class="side-nav">
				<a @click="$router.push('/classroom/'+$route.params.lecId+'/assignment')" class="btn full-width round m-b-10">돌아가기</a>
			</nav>

			<div class="container-fiuld clearfix">
				<div class="title-box m-b-30 b-b clearfix">
					<div class="f-18 pull-left text-blue p-10">과제 관리</div>
					<!--
					<div class="btn-group pull-right p-10 p-r-0">
						<div class="select pull-left m-r-5">
							<a class="btn round pull-left" href="#">
								<img class="v-mid m-r-5" src="images/x.png" alt=""> 액셀 다운로드
							</a>
						</div>
					</div>
					-->
				</div>
				<div class="white-box m-t-10 clearfix">
					<div class="input-group full-width">
						<span class="input-group-addon text-left">
							<p class="f-18 m-b-0 text-bold text-blue">
								과제 - <input class="form-control round f-18 text-blue text-left m-b-0 w400" type="text" style="float: none;" v-model="data.assignName">
								<span class="f-12 text-nomal text-lightgray">{{data.assignName.length}} / 30</span>
							</p>
							<p class="f-14 m-t-10 m-b-0">
								제출기간 :
								<VueCtkDateTimePicker v-model="data.startDate" :no-value-to-custom-elem="true" :no-label="true" format="YYYY-MM-DD" :no-button-now="true" :no-header="true" :only-date="true" class="_date-time-picker" style="float:none;">
									<input type="text" class="form-control round text-left m-b-0 w200" style="float:none;" :value="data.startDate" autcomplete="off">
								</VueCtkDateTimePicker>
								<VueCtkDateTimePicker v-model="data.endDate" :no-value-to-custom-elem="true" :no-label="true" format="YYYY-MM-DD" :no-button-now="true" :no-header="true" :only-date="true" class="_date-time-picker" style="float:none;">
									<input type="text" class="form-control round text-left m-b-0 w200" style="float:none;" :value="data.endDate" autcomplete="off">
								</VueCtkDateTimePicker>
							</p>
						</span>
						<!--
						<span class="input-group-addon v-mid w100">
							<button class="btn btn-blue round">수정완료</button>
						</span>
						-->
					</div>
					<textarea class="full-width m-t-15 v-mid" cols="30" rows="10" placeholder="과제 설명" v-model="data.info"></textarea>
					<span class="f-12 text-nomal pull-right text-lightgray">{{data.info.length}} / 500</span>
					<div class="input-group full-width">
						<span class="input-group-addon w40 v-mid p-r-5">
							<input id="file" type="file" style="display: none;" ref="fileRef" @change="upload">
							<label for="file" class="btn btn-darkgray plus round f-12" type="button">
								<img class="v-mid" src="images/plus.png" width="15" alt="">
							</label>
						</span>
						<span class="input-group-addon v-mid text-white">
							<div class="round on-border bg-white">
								<div class="input-group p-5">
									<span class="input-group-addon" v-for="(file,idx) in data.assignFileMappingList" :key="'assign-files-'+idx">
										{{file.orignlFileNm}}<a class="m-r-5 text-blue text-bold" @click="data.assignFileMappingList.splice(idx,1)">×</a>
									</span>
								</div>
							</div>
						</span>
					</div>
				</div>
			</div>
		</section>

		<modal-confirm :config="modals.ModalConfirm" @yes="modals.ModalConfirm.show=false" @no="modals.ModalConfirm.show=false" :key="hash(modals.ModalConfirm)"></modal-confirm>
		<modal-alert :config="modals.ModalAlert" @close="modals.ModalAlert.show=false;" :key="hash(modals.ModalAlert)"></modal-alert>

		<common-footer></common-footer>
	</fragment>
</template>

<script>
import fnAdjustHeight from '../mixins/fnAdjustHeight.js'
import fnGetLec from '../mixins/fnGetLec.js'
import ClassHeader from '../components/ClassHeader.vue'
import CommonFooter from '../components/CommonFooter.vue'
import ModalConfirm from '../modals/ModalConfirm.vue'
import ModalAlert from '../modals/ModalAlert.vue'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import axios from 'axios'
import server from '../statics/server.js'
import moment from 'moment'

export default {
	name: "ViewClassroomAssignmentRegister",
	mixins: [fnAdjustHeight, fnGetLec],
	// 이 컴포넌트에서 사용할 자식컴포넌트 목록
	components: {
		ClassHeader,
		CommonFooter,
		ModalConfirm,
		ModalAlert,
		VueCtkDateTimePicker
	},

	mounted: async function() {
		const { lecId, curriculumId } = this.$route.params;
		this.lecture = await this.getLecInfo(lecId);
		if(this.lecture.classroomOpt.indexOf("출결")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=='출결')), 1 );
		if(this.lecture.classroomOpt.indexOf("과제")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=="과제")), 1 );
		if(this.lecture.classroomOpt.indexOf("설문")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=='설문')), 1 );
		if(this.lecture.classroomOpt.indexOf("시험")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=='시험')), 1 );
		//if(this.lecture.classroomOpt.indexOf("동영상 등록")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=='강의 목차')), 1 );
		this.curriculum = await this.getCurriculumInfo(curriculumId);
	},

	// 이 컴포넌트에서 내부적으로 사용할 데이터
	data: function() {
		return {
			lecture: {},
			menus : [
				{name:'강의 목차',link:"/classroom/"+this.$route.params.lecId+"/curriculum",selected:false},
				{name:'수강관리',link:"/classroom/"+this.$route.params.lecId+"/apply",selected:false},
				{name:'출결',link:"/classroom/"+this.$route.params.lecId+"/attendance",selected:false},
				{name:'시험',link:"/classroom/"+this.$route.params.lecId+"/exam",selected:false},
				{name:'과제',link:"/classroom/"+this.$route.params.lecId+"/assignment",selected:true},
				{name:'설문',link:"/classroom/"+this.$route.params.lecId+"/survey",selected:false},
				{name:'게시판',link:"/classroom/"+this.$route.params.lecId+"/board",selected:false},
			],
			buttons : [
				{name:'저장하기', fn:this.register}
			],
			modals: {
				ModalConfirm: ModalConfirm.default(),
				ModalAlert: ModalAlert.default()
			},
			data: {
				assignName: "",
				startDate: "",
				endDate: "",
				info: "",
				assignFileMappingList: []
			}
		}
	},

	// 이 컴포넌트에서 내부적으로 사용할 메써드
	methods: {
		// 과제 등록
		register: function() {
			axios.put(server.addr()+"/assign", [{...this.data, lecId:this.$route.params.lecId, curriculumId:this.$route.params.curriculumId}]).then( () => {
				this.$router.push('/classroom/'+this.$route.params.lecId+"/assignment");
			})
		},
		upload: async function() {
			const formData = new FormData();
			formData.append("file", this.$refs.fileRef.files[0]);
			axios.post(`${server.addr()}${server.api.FILE}`, formData).then((response) => {
				this.data.assignFileMappingList.push({atchFileId:response.data,orignlFileNm:this.$refs.fileRef.files[0].name});
			})
		},
	},

	filters: {
		parseRegDate(date){
			return moment(date).format('YYYY-MM-DD')
		},
	}
}
</script>
